const MONTHS = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
];
const THIS_MONTH = new Date().getMonth();
const getMonthName = (month = THIS_MONTH)=>MONTHS[month];
const date_getMonthName = getMonthName;
export default date_getMonthName;
